import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import GenericTable from '../components/liquidInstance/GenericTable';
import WrapUnwrap from '../components/liquidInstance/WrapUnwrap';
import { useLiquidInstanceContext } from '../context/liquidInstanceContext';
import { Instance } from '../types/liquidInstance';
import { useState } from 'react';
import { useEffect } from 'react';

export default function LiquidInstances() {
  const { id } = useParams();
  const { instances, liquidInstanceConfiguration } = useLiquidInstanceContext();
  const [loading, setLoading] = useState(true);
  const [validId, setValidId] = useState(false);

  useEffect(() => {
    const validId = id ? instances.some((instance: Instance) => instance.name.toLowerCase() === id) : false;
    setValidId(validId);
  }, [id, instances]);
  useEffect(() => {
    if (instances && liquidInstanceConfiguration.L2?.name) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [instances, liquidInstanceConfiguration.L2]);
  if (loading) {
    return (
      <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
        Loading...
      </Box>
    );
  }

  return (
    <Box width="100%" height="100%">
      {!validId ? <GenericTable /> : <WrapUnwrap />}
    </Box>
  );
}
